/** Tenant id `0` is valid (Freyr / system tenant); do not treat it as missing. */
export function isMissingTenantId(id: unknown): boolean {
  return id === null || id === undefined || id === "";
}

export function shouldSkipTenantSwitch(
  nextId: unknown,
  currentId: unknown
): boolean {
  if (isMissingTenantId(nextId)) {
    return true;
  }
  return String(nextId) === String(currentId);
}

/** Resolve the active AC tenant for layout providers / Outlet remount key. */
export function resolveActiveTenantId(options: {
  locationTenantId?: unknown;
  sessionTenantId?: unknown;
  fallbackTenantId?: unknown;
}): string {
  const { locationTenantId, sessionTenantId, fallbackTenantId } = options;
  if (!isMissingTenantId(locationTenantId)) {
    return String(locationTenantId);
  }
  if (!isMissingTenantId(sessionTenantId)) {
    return String(sessionTenantId);
  }
  if (!isMissingTenantId(fallbackTenantId)) {
    return String(fallbackTenantId);
  }
  return "";
}
